var _defs, _circle, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirtelLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.66 50.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d7101f;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.33,
    cy: 25.33,
    r: 25.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.31,29.19a.38.38,0,0,1-.37-.4V24.32l-1,.16v4.28A1.1,1.1,0,0,0,41,29.88h.56v-.69Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.62 29.88 30.63 29.88 30.63 25.63 29.62 25.79 29.62 29.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.27,26.38v3.5h1V26.77c0-.51,1.16-.42,1.16-.42l.37-.79A2.38,2.38,0,0,0,31.27,26.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.14,28.79V26.33h.6v-.78h-.6V24.32l-1,.16v4.28a1.1,1.1,0,0,0,1.07,1.12h.57v-.69h-.26A.39.39,0,0,1,35.14,28.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.13,24a.63.63,0,1,0,.62.62A.63.63,0,0,0,30.13,24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.68,29.1c-.67-.26-.62-1.26-.62-1.26h2.43c0-1.26-.31-2.35-1.53-2.35a1.94,1.94,0,0,0-2,2.16,2,2,0,0,0,2,2.23,2.9,2.9,0,0,0,1.52-.43l-.35-.6A2,2,0,0,1,37.68,29.1Zm.14-2.84c.58,0,.7.82.7.82h-1.4S37.24,26.26,37.82,26.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.62,25.52a6.14,6.14,0,0,0-.86.09A2.62,2.62,0,0,0,26,26l.32.66a1.67,1.67,0,0,1,1.06-.39.72.72,0,0,1,.74.86c-1.67-.34-2.5.52-2.48,1.41a1.2,1.2,0,0,0,.53,1.11A2.4,2.4,0,0,0,29,29.18V26.84A1.37,1.37,0,0,0,27.62,25.52ZM28.05,29a1.36,1.36,0,0,1-1.09.05.7.7,0,0,1,0-1.16,1.86,1.86,0,0,1,1.06-.08Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.14,21c-4.57,4.14-2.92,5.52-1.83,6s2.55-.2,4.37-1.62,6.05-4.17,7-2.81,1,4.09-3.25,7.67-5.14,1.49-3-.15,1.72-2.63.72-2.78-1.94.1-2.87,1.8c0,0-1.42,2.75.4,3.45,1.26.49,5-1,7.75-3.78,2-2,3.5-4.48,2.88-7.72C23.5,16.88,16.71,16.89,12.14,21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtelLogo);
export default __webpack_public_path__ + "static/media/airtel-logo.1d7afc392bb18054c1993d8e6937bb60.svg";
export { ForwardRef as ReactComponent };